/**
 * Created by Sasha on 7/25/2018.
 */
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class FuncionTypeService  {
  functionTypes: any[];
  onFunctionTypeChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getFunctionTypes()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getFunctionTypes () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/functionType/functionTypes'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.functionTypes = response;
          this.onFunctionTypeChanged.next(this.functionTypes);
          resolve(response);
        }, reject);
    });

  }

  getFunctionById(id) {
    return this.http.get(this.api.baseUrl + '/functionType/functionType?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteFunctionType(id) {
    return this.http.delete(this.api.baseUrl + '/functionType/deleteFunctionType?id=' + id , this.api.jsonTokenHeaders);
  }

  addFunctionType(data) {
    return this.http.post(this.api.baseUrl + '/functionType/addFunction' , data , this.api.formDataHeaders);
  }

  getFunctionTypeDropDown() {
    return this.http.get(this.api.baseUrl + '/functionType/functionTypes'  , this.api.jsonTokenHeaders);
  }
}
